import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, X } from "lucide-react";
import { api } from "@/lib/api";
import { useTeam } from "@/lib/team";

const KEY = "snaplist.overdueDismissed";

// Lister-only: nudge about sent batches still unfinished after a day. Dismissed for this browser session.
export default function OverdueNudge() {
  const { isAssistant, canList } = useTeam();
  const [rows, setRows] = useState([]);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(KEY) === "1");
  useEffect(() => {
    if (!isAssistant || !canList || hidden) return;
    api.get("/photo-batches/overdue").then(({ data }) => setRows(data.batches || [])).catch(() => {});
  }, [isAssistant, canList, hidden]);
  if (hidden || !rows.length) return null;
  const b = rows[0];
  const days = Math.max(1, Math.floor((Date.now() - new Date(b.created_at).getTime()) / 86400000));
  return (
    <div className="mb-4 flex items-center gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-900" data-testid="overdue-nudge">
      <Clock className="h-4 w-4 shrink-0 text-amber-600" />
      <span className="min-w-0 flex-1">
        <b>“{b.name}”</b> has waited {days} day{days === 1 ? "" : "s"}. <b className="font-mono">{b.left}</b> item{b.left === 1 ? "" : "s"} left to list
        {rows.length > 1 ? `, plus ${rows.length - 1} more batch${rows.length > 2 ? "es" : ""}` : ""}.
      </span>
      <Link to={`/batch?b=${b.id}`} className="shrink-0 rounded-full bg-amber-500 px-3 py-1 font-semibold text-white hover:bg-amber-600" data-testid="overdue-nudge-open">Open</Link>
      <button type="button" aria-label="Dismiss" onClick={() => { sessionStorage.setItem(KEY, "1"); setHidden(true); }}
        className="shrink-0 rounded p-1 text-amber-700 hover:bg-amber-100" data-testid="overdue-nudge-dismiss"><X className="h-3.5 w-3.5" /></button>
    </div>
  );
}
